<template>
  <div
    :class="[
      'add_media',
      responsive ? 'responsive' : '',
    ]"
  >
    <div class="input_content">
      <div class="icon_wrapper">
        <svg-vue icon="icons/media" />
      </div>
      <span class="title">
        <slot />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    responsive: {
      type: Boolean,
      default: false,
    },
  }
}
</script>

<style lang="scss" scoped>
.add_media {
  width: 230px;
  height: 230px;
  display: block;
  border: 2px solid #37B2A8;
  border-radius: 0.75rem;
  cursor: pointer;
  padding: 0.5rem;
  margin-top: 1rem;

  &.responsive {
    width: 100%;
    height: 100%;
    margin-top: 0;
  }

  > .input_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    opacity: 1;
    transition: .3s;
    padding: 0 10px;
    text-align: center;
    position: relative;
    width: 100%;
    height: 100%;

    > .icon_wrapper {
      display: flex;
      align-items: center;
      justify-content: center;

      > :deep(svg) {
        width: 3rem;
        height: 3rem;

        > path {
          stroke: #37B2A8;
        }
      }
    }

    > .title {
      color: #37B2A8;
      font-weight: 700;
      line-height: 1.45;
      letter-spacing: -0.042em;
      font-size: 1.125rem;
    }
  }
}
</style>
